<template>
	<div>
		<table class="table table-bordered table-hover mb-0">
	 
	  <tbody>
		<tr @click="showModal(value)">
			<td class="center-both align-middle text-muted" style="width: 6%;">
				<span v-if="value.request_id"> {{ value.request_id }}(R)</span>
				<span v-else>{{ value.appeal_id }}</span>
			</td>
			<td class="center-both align-middle" style="width: 7%;">
			<b-badge 
			:title="value.status_label"
			pill
			:variant="value.progress_variant"
			>
			<span>{{ value.status_label }}</span>
			</b-badge>
		  </td>
		  <td class="center-both align-middle font-weight-bold"  :title="patientName" style="width: 7%;">{{ patientName.substring(0, 12) }}</td>
	  
		  <td class=" center-both  align-middle" style="width: 10%;">
			<span v-if="value.facility_name" :title="value.facility_name">{{ value.facility_name.substring(0, 18) }}</span>
			<div v-else class="text-muted">&mdash;</div>
		  </td>
	
	
	  
	
	   <!-- <td class="col-md-2 center-both align-middle "   @click="navigateToAppeal">
			<div v-if="!hideAgency">
		<p v-if="value.agency" class="text-muted " title="Agency">
			
			<span v-if="value.agency && value.agency.name" class="mb-0">
				{{ value.agency.name }}
			</span>
		</p>
		<p v-else  title="No Agency Provided">
			
			<span class="font-weight-bold  center-both align-middle">{{ agencyName }}</span>
		</p>
	</div>
	<div v-else class="text-muted">&mdash;</div>
	
		  </td> -->
		  
		  <td class=" center-both align-middle "  style="width: 12%;"  >
			<span v-if="value.submit_to" :title="value.submit_to">{{ value.submit_to.substring(0, 29)}}</span>
			<div v-else class="text-muted">&mdash;</div>
		  </td>
	
		  <td class=" center-both align-middle "  style="width: 7%;" >
						   
						<span>{{ value.name_of_submit_to }}</span>
	
		  </td>
		  <td class=" center-both align-middle "   style="width: 7%;" >
			<h2 v-if="entity.name"
				 tag="h3"
				 class="h6 mb-0 "
				 :title="entity.name"
				
			>
			<font-awesome-icon icon="envelope" />
			{{ entity.name.substring(0, 11) }} 
		  </h2>
						   <div v-else-if="appealLevel" class=" align-middle" :title="appealLevel">
							<font-awesome-icon icon="envelope-open" />	 {{ appealLevel.substring(0, 11) }}
						   </div>
				
						   <div v-else>
							&mdash;
						   </div>
	
		  </td>
		  <td class=" center-both align-middle"  style="width: 7%;" >
						   
					 {{ $filters.formatDate(value.created) }}
	
		  </td>
		  <td class=" center-both align-middle" style="width: 7%;">
								<p v-if="value.delivery_method" class="text-muted mb-0" title="Delivery Method">
									<font-awesome-icon
										v-if="value.delivery_method_icon"
										:icon="value.delivery_method_icon"
										fixed-width
									/>
									<span v-if="value.delivery_method && value.delivery_method_label" class="mb-0">
										{{ value.delivery_method }}
									</span>
								</p>			
		  </td>
		  <td class="center-both align-middle" style="width: 7%;">
			<b-dropdown right class="mb-0">
							<template #button-content>
								<font-awesome-icon icon="file-download" fixed-width />
							</template>
							<b-dropdown-item
							@click="download" title="Download Packet"
							>
								Download
							</b-dropdown-item>
							<b-dropdown-item
								@click="preview"
							>
								Preview 
						</b-dropdown-item>
						</b-dropdown>
		  </td>
			
		  <!--<td class="col-md-1">
			<b-button @click="download" title="Download Packet" class="ml-2">
			  <font-awesome-icon icon="file-download" fixed-width />
			</b-button>
		  
		  </td>  -->
		  
		  <!-- 
		  <td class="col-md-1">
			<b-button
							variant="primary"
							@click="markDelivered"
							:disabled="isDelivered || isCancelled"
							class="mb-0 ml-1"
						>
							<span v-if="isDelivered">Delivered</span>
							<span v-else>Mark Delivered</span>
						</b-button>
							<b-dropdown right class="mb-0">
							<template #button-content>
								<font-awesome-icon icon="cog" />
							</template>
							<b-dropdown-item
								v-if="!hideViewAppeal"
								:to="{
									name: 'appeals.view',
									params: { id: value.case_id, appeal_id: value.appeal_id },
								}"
							>
								View Appeal
							</b-dropdown-item>
							<b-dropdown-item
								v-if="value.agency_id && !hideAgency"
								:to="{
									name: 'agencies.view',
									params: { id: value.agency_id },
								}"
							>
								View Agency
							</b-dropdown-item>
	
							<b-dropdown-divider v-if="!(hideAgency && hideViewAppeal)" />
	
							<b-dropdown-item @click="retry" :disabled="!value.can_retry"> Retry </b-dropdown-item>
							<b-dropdown-item @click="cancel" :disabled="!value.can_cancel"> Cancel </b-dropdown-item>
						</b-dropdown>
		  </td> -->
		</tr>
	   </tbody>
	  
	</table>
	<!--
	<b-modal id="manualDeliveryModal"  v-if="modalcount" hide-footer hide-header>
		<div style="display: flex; justify-content: space-between; align-items: center;">
	  <h5 style="margin: 0;">Mail Delivery Information</h5>
	  <div>
		 Your custom cross icon button 
		<span aria-hidden="true" @click="cancelModal" style="cursor: pointer; font-size: 24px;">&times;</span>
	
		
	  </div>
	</div>
	<hr>
	
		 
		  <div>
			<p><strong>Mail Notes:</strong> {{ this.storedData.mailNotes }}</p>
			<p><strong>Carrier:</strong> {{ this.storedData.carrier }}</p>
			<p><strong>Tracking:</strong> {{ this.storedData.tracking }}</p>
		  </div>
		 <hr>
		  <div class="text-center">
		<button @click="cancelModal" class="btn btn-secondary">Cancel</button>
	  </div>
		
		</b-modal>
	-->
		<b-modal id="info-modal" ref="infoModal" hide-footer>
			<template #modal-header>
				<h4>Outgoing {{ value.delivery_method }}</h4>
				<b-badge :variant="value.progress_variant" pill class="b-badge-lg b-badge-lg-custom d-inline-block d-sm-inline-flex">
					{{ value.status_label }}
				</b-badge>
	
	  		</template>
		 
		  
			
			<p><font-awesome-icon icon="user" />
				<strong>Patient :</strong> 
					{{ patientName }}</p>
		  
		  <p>	
			<font-awesome-icon icon="building" class="px-0 mx-0" />
									
		  <strong>Facility :</strong> {{ value.facility_name }}</p>
		  <p>
										<font-awesome-icon icon="user-md" class="px-0 mx-0" />
									
			<strong>Recipient :</strong> {{ value.submit_to }}</p>
		  <p>
										<font-awesome-icon icon="building" class="px-0 mx-0" />
									
			<strong>Recipient Type:</strong> {{ value.name_of_submit_to }}</p>
		  <div>
			<p v-if=" entity.name"> <font-awesome-icon icon="envelope" /><strong> Level:</strong> {{  entity.name }}</p>
			<p v-else><font-awesome-icon icon="envelope-open" /><strong> Level:</strong> 
				{{  appealLevel }}</p>
		  </div>
		 <div>
			<p v-if=" value.email"> <font-awesome-icon
										v-if="value.delivery_method_icon"
										:icon="value.delivery_method_icon"
										fixed-width
									/><strong> Email:</strong> {{  value.email}}</p>
		   <p v-if="value.fax">
			<font-awesome-icon
										v-if="value.delivery_method_icon"
										:icon="value.delivery_method_icon"
										fixed-width
									/><strong> Fax:</strong> {{  value.fax }}</p>
		 </div>
		  <p>
			<strong>Sent Date:</strong>
			 {{ $filters.formatDate(value.created) }}</p>
		  
		   <div v-if="value.delivery_method === 'MAIL'">
			<p><strong>Mail Notes:</strong> {{ value.mailNotes }}</p>
			<p><strong>Carrier:</strong> {{ value.carrier }}</p>
			<p><strong>Tracking:</strong> {{ value.tracking }}</p>
		  </div>
		   
			<div>
					   <b-dropdown right class="mb-0">
							<template #button-content>
								<font-awesome-icon icon="file-download" fixed-width />
							</template>
							<b-dropdown-item
							@click="download" title="Download Packet"
							>
								Download
							</b-dropdown-item>
							<b-dropdown-item
								@click="preview"
							>
								Preview
							</b-dropdown-item>
						</b-dropdown>
	
			</div>
		
		<hr>
		<div class="d-flex justify-content-between">
			<b-button @click="hidemodal" variant="light" class="btn btn-outline-danger">Close</b-button>
			<b-button v-if="showViewCase" @click="navigateToAppeal" variant="light" class="btn btn-outline-primary">View Case</b-button>
			<font-awesome-icon v-if="!showModalData && !showViewCase" icon="circle-notch" spin fixed-width />
			<span v-if="showModalData && !showViewCase" class="text-muted">This appeal has been deleted</span>
		</div>
		</b-modal>
		
	</div>
	</template>
	
	<script>
	import axios from "axios";
	export default {
		name: "OutgoingDocumentListItem",
		props: {
			value: {
				type: Object,
				default: () => {
					return {
						id: null,
						case_id: null,
						appeal_id: null,
						agency_id: null,
						delivery_method: null,
						delivery_method_label: "",
						delivery_method_icon: "",
						status_message: "",
						can_cancel: false,
						can_retry: false,
						progress_indeterminate: false,
						progress_percent: 0,
						progress_variant: "",
						request_id: null,
						facility_name: null,
						name_of_submit_to: null,
						submit_to:null,
						mailNotes: null,
						carrier: null,
						tracking:null,
						email:null,
						fax: null,
						agency: {
							id: null,
							name: null,
						},
						case: {
							id: null,
							patient_id: null,
							patient: {
								id: null,
								full_name: null,
								
							},
							facility_id: null,
							facility:{
								 id: null,
								 name: null,
							},
						},
						appeal: {
							id: null,
							pdf_url:null,
							appeal_level_id: null,
							appeal_level: {
								id: null,
								name: null,
							},
						},
						created_by_user: {
							id: null,
							full_name: null,
						},
					};
				},
			},
			hideViewAppeal: {
				type: Boolean,
				default: false,
			},
			hideAgency: {
				type: Boolean,
				default: false,
			},
		},
		data() 
		{
			return {
					outgoingList:[],
					appealLevelName:'',
					appealList:[],
					agencyList:[],
					agencyName:null,
					entity: this.value,
					loading: true,
					error: false,
					storedData: {
						carrier: '',
						tracking: '',
						mailNotes: '',
					},
					modalcount:false,
					modalVisible: false,
					modalData: {
						patient : '',
						facility_name : ' ',
						agencyName: '',
					},
					showModalData:false,
					showViewCase:false,
				};
		},
		computed: {
			patientName() {
				
				return this.value.case?.patient?.full_name ?? "(Missing Name)";
			},
			facilityName() {
				return this.value.case?.facility?.name ?? "(Missing Name)";
			},
	
			appealLevel() {
				this.outgoingList.forEach((item, index)=>{
					try{
					if(item.id ==this.value.appeal.insurance_appeal_id){
						
						this.appealLevelName = item.label;
					}
					}
					catch (err) {
					
					}
				});
				// return this.value.appeal?.appeal_level?.name ?? "(Missing Level)";
				//below code for rendering agency 
				if(this.appealList.length = 0){
					this.appealList.forEach((item, index)=>{
						if(this.value.appeal_id == item.id){
							this.agencyList.forEach((agency , indexAgency ) => {
								if(item.agency_id == agency.id){
									this.agencyName = agency.name;
								
								}
							});
						}
					});
					return this.appealLevelName;
				}
				return "";
			},
			isDelivered() {
				return this.value.status_message == "DELIVERED";
			},
			isCancelled() {
				return this.value.status_message == "CANCELLED";
			},
		},
		methods: {
			async showModal(data) {
				this.modalData = data;
				this.$refs.infoModal.show();
				this.showModalData = false;
				try{
					const response = await this.$store.dispatch("appeals/get", {
						id: this.value.appeal_id,
					});
					
					if(response.deleted === null){
						this.showViewCase = true;
					
					}
					else{
						this.showViewCase = false;
						
					}
					this.showModalData = true;
					this.$forceUpdate();
					
				}
				catch(error) {
					this.showViewCase = false;
					this.showModalData = true;
					this.$forceUpdate();
					
				}	
			},
		  hidemodal (){
			  this.$refs.infoModal.hide();
			  this.showModalData = true;
		  },
			async refresh() {
		try {
			this.loading = true;
			this.error = false;
	
			// Check if request_id is not null before making the request
			if (this.value.request_id !== null) {
				const response = await this.$store.dispatch("caseRequests/get", {
					case_id: this.value.case_id,
					id: this.value.request_id,
				});
				this.entity = response;
				
			}
	
		} catch (e) {
			this.error = true;
			this.$store.dispatch("apiError", {
				error: e,
				message: "Failed to find request",
			});
		} finally {
			this.loading = false;
		}
	},
	
	
			async markDelivered() {
				const response = await this.$store.dispatch("outgoingDocuments/delivered", {
					id: this.value.id,
				});
	
				this.$store.dispatch("notify", {
					variant: "primary",
					title: "Documents Delivered",
					message: `Document for ${this.patientName} has been marked as delivered`,
				});
	
				this.$emit("updated", response);
			},
			async cancel() {
				const response = await this.$store.dispatch("outgoingDocuments/cancel", {
					id: this.value.id,
				});
	
				this.$store.dispatch("notify", {
					variant: "warning",
					title: "Documents Cancelled",
					message: `Document for ${this.patientName} has been marked as cancelled`,
				});
	
				this.$emit("updated", response);
			},
			async retry() {
				const response = await this.$store.dispatch("outgoingDocuments/retry", {
					id: this.value.id,
				});
	
				this.$store.dispatch("notify", {
					variant: "primary",
					title: "Documents Requeued",
					message: `Document for ${this.patientName} has been marked as new and requeued for sending`,
				});
	
				this.$emit("updated", response);
			},
			async download() {
				return await this.$store.dispatch("outgoingDocuments/download", {
					id: this.value.id,
				});
			},
			async test(){
				const url = "/client/insuranceappeal";
					
					const response = await axios.get(url, {
					headers: {
						"Accept": "application/json",
						// You can add other headers here if needed
					},
					});
					
					this.outgoingList = response.data;
				
				const appealListUrl = '/client/appealList';
				const appealListResponse = await axios.get(appealListUrl, {
					headers: {
						"Accept": "application/json",
						// You can add other headers here if needed
					},
					});
					
					this.appealList = appealListResponse.data;
					const agencyListUrl = '/client/agencyList';
				const agencyListResponse = await axios.get(agencyListUrl, {
					headers: {
						"Accept": "application/json",
						// You can add other headers here if needed
					},
					});
					
					this.agencyList = agencyListResponse.data;
					
			},
			navigateToAppeal() {
				if (this.value.request_id !== null) {
					this.$router.push({
					name: 'caseRequests.view',
					params: { id: this.value.case_id, case_request_id: this.value.request_id },
						});
				} else {
					this.$router.push({
					name: 'appeals.view',
					params: { id: this.value.case_id, appeal_id: this.value.appeal_id },
				});
				}
			},
	preview() {
		  
		  const pdfUrl = `/client/api/appeals/${this.value.id}/pdf?param=${this.value.filename}` ;
		  if (pdfUrl) {
			window.open(pdfUrl, "_blank");
		  } else {
			console.error("PDF URL is not available");
		  }
		},
		
		handleDeliveryMethodClick() {
		  if (this.value.delivery_method === "Manual") {
			
			this.storedData.carrier = this.value.carrier;
		  this.storedData.tracking = this.value.tracking;
		  this.storedData.mailNotes = this.value.mailNotes;
		  
		  this.modalcount = true;
		  this.$nextTick(() => {
		  this.$bvModal.show('manualDeliveryModal');
		});
		  } else {
			// If not "Manual," navigate to appeal
			this.navigateToAppeal();
		  }
		},
		cancelModal() {
		  // Close the modal by toggling the modalcount property
		  this.modalcount = false;
		},
	
		},
		mounted() {
			this.test();
			this.refresh();
		}
	};
	</script>
	
	<style>
	
	.center-both {
		align-items: center;
		justify-content: center;
	  }
	.table{
		cursor: pointer;
	}
	.b-badge-lg-custom {
	  font-size: 12px; /* Adjust the font size as needed */
	  padding: 7px 7px; /* Adjust padding as needed */
	}
	</style>